import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import { Subheading, TopicHeader } from './detail/styles'
import { filterTippedCreditAmount } from './detail/services'
import { ContentBlock } from './contentBlock'

export default function TopicItem({ performScroll, jurisdictionType, topic, stateCode, topicItem, currentTopic }) {
  return (
    <React.Fragment key={`${jurisdictionType}_${topic}`}>

      <TopicHeader
        data-topic={topic}
        className={currentTopic === topic ? 'activeContent' : null}
        onClick={() => {
          performScroll(topic)
        }}
      >
        {topic}
      </TopicHeader>
      {Object.keys(topicItem)
        .map((subTopic) => {
          const contentBlocks = getFilteredContentBlocks(stateCode, topicItem, subTopic)

          return (
            <React.Fragment key={uuidv4()}>
              { renderTitle( topic, subTopic)}
              { contentBlocks ? contentBlocks.map((block) => (<ContentBlock contentBlock={block} key={uuidv4()} />)) : null }
            </React.Fragment>
          )
        })}
    </React.Fragment>
  )
}

const getFilteredContentBlocks = function (stateCode, topicItem, subTopic) {
  let filteredContentBlocks = []
  const contentBlocks = topicItem[subTopic].contentBlocks
  if (subTopic === 'Tipped Credit Amount') {
    filteredContentBlocks = filterTippedCreditAmount(stateCode, contentBlocks)
  } else {
    filteredContentBlocks = contentBlocks
  }
  return filteredContentBlocks
}

const renderTitle = function (topicTitle, subTopicTitle) {
  // don't render the subtopic title if it is the same as the title
  if (subTopicTitle && subTopicTitle !== topicTitle) {
    return <Subheading>{subTopicTitle}</Subheading>
  }
  return null
}
